import React from 'react';
import { Parser } from 'html-to-react';

import PropTypes from 'prop-types';
import PageTitle from '../../../components/pageTitle';
import Navigation from '../../../components/navigation';
import Reactions from '../../../components/reactions';
import PageService from '../../../services/page.service';
import sh from '../../../helpers/string.helper';

const htmlToComponents = new Parser().parse;


const SimplePage = ({
  t,
  page,
  backgroundCover,
  enableCoverColor,
  backgroundColor,
}) => (
  <React.Fragment>
    {page &&
    <section className="Blog2 boxs knwldgeBase_D">
      <PageTitle
        title={page.title}
        backgroundPage={backgroundColor}
        backgroundCover={backgroundCover}
        enableCoverColor={enableCoverColor}
      />
      <div className="container">
        <div className="Blog2inner boxs pdlr forlineBlog forlineBlogleft">
          <svg aria-hidden="true" focusable="false" style={{ width: 0, height: 0, position: 'absolute' }}>
            <linearGradient id="gradientfill" className={`emoj-list ${backgroundColor}`}>
              <stop offset="0%" stopColor="var(--color-stop-1)" />
              <stop offset="100%" stopColor="var(--color-stop-2)" />
            </linearGradient>
          </svg>
          <Navigation cssClass="leftKB" />
          <div className="middleKB">
            <div className="middleinner boxs">
              <div className="kbleftw">
                <div className="Blog2t_outer ">
                  <div className="simplepage2 ">
                    <div className="Blogs2 ">
                      <div className="BlogsBoxouter ">
                        <div className="BlogsBox  BlogsBoxkb">
                          <div className="bottom imrtant-style">
                            {page.content && htmlToComponents(sh.replaceSpecialChars(page.content))}
                          </div>
                        </div>
                      </div>
                    </div>
                    <Reactions
                      cssClass={`emoj-list ${backgroundColor}`}
                      model_id={page.id}
                      model_name={PageService.modelName}
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>}
  </React.Fragment>
);

SimplePage.propTypes = {
  t: PropTypes.func.isRequired,
};

export default SimplePage;



// WEBPACK FOOTER //
// ./src/views/modules/simplePage/SimplePage.jsx